import { InMemoryCache } from '@apollo/client';

export const getCache = () => new InMemoryCache();